/*
----------------------------
Module - events-map
----------------------------
*/

import $ from 'jquery';
/*global fmg*/
/*global google*/

(function(){

    fmg.eventsMap = function(){
        
        function init() {

            var $map_container = $(".events-map");

            if($map_container.length) {

                getMapCoordinates();

            }
   
        }

        function getMapCoordinates() {

            var address = $(".events-map").data("address");
            
            var coordinates = {};

            var geocoder = new google.maps.Geocoder();

            // Retrieve lat lng values based on address metadata value
            geocoder.geocode({ 'address': address }, function (results, status) {

                if (status == google.maps.GeocoderStatus.OK) {

                    if (results[0]) {
                        
                        coordinates['lat'] = results[0].geometry.location.lat();
                        coordinates['lng'] = results[0].geometry.location.lng();
                        
                        // Store values in global vars
                        lat_lng = coordinates;
                        formatted_address = address;
                        place_id = results[0].place_id;
                        
                        buildMap();
                    }

                }

                else {

                    alert("Please check that the location address is valid for this event");

                    console.log(status)

                }

            });

        }

        function buildMap(){

             // The map is centered at specified location
            $map = new google.maps.Map(document.getElementsByClassName("events-map__map")[0], {
                zoom: 15,
                center: lat_lng,
                clickableIcons: false,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM,
                    mapTypeIds: ["roadmap", "satellite"]
                }
            });

            buildMarker(); 

        }

        function buildMarker() {
            
            // Create and render marker 
            $marker = new google.maps.Marker({
                position: lat_lng,
                map: $map
            });
    
            buildMarkerUrls(); 

        }
    
        function buildMarkerUrls() {
            
            var base_map_url = "https://www.google.com/maps/search/?api=1&query=";
            var base_directions_url = "https://www.google.com/maps/dir/?api=1&destination=";

            if ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPad") != -1) || (navigator.platform.indexOf("iPod") != -1)){
                base_map_url = "maps://www.google.com/maps/search/?api=1&q=";
                base_directions_url = "maps://www.google.com/maps/dir/?api=1&daddr=";
            }
    
            // Place IDs will take precedence, but will fall back to the lat lng values if it doesn't exist
            var full_map_url = base_map_url + lat_lng.lat + "," + lat_lng.lng + "&query_place_id=" + place_id;
            var full_directions_url = base_directions_url + lat_lng.lat + "," + lat_lng.lng + "&destination_place_id=" + place_id;
        
            // Attach map URL to marker
            $marker['map_url'] = full_map_url;
            // Attach directions URL  to marker
            $marker['directions_url'] = full_directions_url;

            createMarkerInfoBox(); 

        }

        function createMarkerInfoBox() {

            var $info_window_content = '<div class="">' +
                            
                '<div class="events-infobox__inner">' +
                
                    '<span class="events-infobox__address">' + formatted_address + '</span>' +
                
                    '<div><a target="_blank" href="' + $marker['map_url'] + '" class="events-infobox__link events-infobox__link--map">View larger map</a></div>' +
                    
                    '<div><a target="_blank" href="' + $marker['directions_url'] + '" class="events-infobox__link events-infobox__link--directions">Directions</a></div>' +
                        
                '</div>' +
                
            '</div>';

            // Create infowindow and set the content
            var $info_window = new google.maps.InfoWindow({

                content: $info_window_content,
                
                maxWidth: 328

            })

            // Open info window by default
            $info_window.open($map, $marker); 
            
            // Click marker to open info window
            $marker.addListener("click", () => {

                $info_window.open($map, $marker);

            });

        }

        var place_id;
        var $map;
        var $marker;
        var lat_lng;
        var formatted_address;

        return {
            init: init
        };

    }();
    
    document.addEventListener("DOMContentLoaded", function () {
        fmg.eventsMap.init();
    });

}());
